module.exports = __webpack_public_path__ + "static/img/3.2e42e7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/3.png
// module id = xEYL
// module chunks = 0